import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackEvent } from '../utils/gt';
import { useConfirmedEmailNotice } from '../utils/useConfirmedEmailNotice';

import { useAuthDialog } from './auth/authDialogContext';
import { LandingNav } from './landing/LandingNav';

export const Navbar = () => {
  const { openAuth } = useAuthDialog();
  const { pathname, state } = useLocation();

  // /login opens the sign-in window: an expired session lands on /login/<the page it was on>; plain "go log in"
  // links (after a password reset) pass state.quiet
  useEffect(() => {
    if (/^\/login/.test(pathname)) {
      openAuth('login', { expired: !state?.quiet });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useConfirmedEmailNotice({ onLogin: () => openAuth('login') });

  // Public pages (landing, /login behind its window, terms, reset password) use the landing nav, pinned to the top
  // while the page scrolls; app pages have their own header and the floating tab bar
  return (
    <div className="mt-root mt-nav-wrap">
      <LandingNav
        onLogin={() => {
          trackEvent('navbar_login', 'Navbar - Click Login', 'navbar', true);
          openAuth('login');
        }}
        onSignup={() => {
          trackEvent('navbar_signup', 'Navbar - Click Signup', 'navbar', true);
          openAuth('signup');
        }}
      />
    </div>
  );
};
